import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { VariantColor } from '@repo/toolkit/colors'
import { NumberFormatter } from '@repo/toolkit/number'
import Badge from '@repo/ui/badge'
import Box from '@repo/ui/box'
import Typography from '@repo/ui/typography'

import { CurrencyEnum } from '../../../../lib/types/enums/common/currency.enum'

type AmountItem = {
  label: string
  amount: number
  isBadge?: boolean
  variant?: VariantColor
  textColor?: string
  bgColor?: string
  hideItem?: boolean
}

type Props = {
  title: string
  currency?: CurrencyEnum
  total: AmountItem
  amounts: AmountItem[]
  className?: string
  hideTotal?: boolean
}

const PaymentDistribution = ({
  title,
  currency,
  total,
  amounts,
  className,
  hideTotal = true
}: Props) => {
  return (
    <div>
      <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
        {title}
      </Typography>
      <div className="h-2" />
      <Box
        className={cn(
          'bg-white-dark border border-grey-light w-full flex justify-between rounded py-2 px-3',
          className,
          { 'justify-end mobile:justify-start': hideTotal }
        )}
      >
        {!hideTotal && (
          <div className="flex items-center gap-1">
            <Typography variant="tag" color={tailwindColors.black.DEFAULT}>
              {total.label} :
            </Typography>
            {total.isBadge ? (
              <Badge
                textColor={total.textColor}
                color={total.bgColor}
                variant={total.variant}
                text={NumberFormatter.formatCurrency(total.amount, currency)}
              />
            ) : (
              <Typography variant="label-semibold" color={tailwindColors.black.DEFAULT}>
                {NumberFormatter.formatCurrency(total.amount, currency)}
              </Typography>
            )}
          </div>
        )}
        <div className="flex items-center gap-4">
          {amounts
            .filter((item) => !item.hideItem)
            .map((item, index) => (
              <div key={index} className="flex items-center gap-1">
                <Typography variant="label-semibold" color={tailwindColors.black.DEFAULT}>
                  {item.label} :
                </Typography>
                {item.isBadge ? (
                  <Badge
                    textColor={item.textColor}
                    color={item.bgColor}
                    variant={item.variant}
                    text={NumberFormatter.formatCurrency(item.amount, currency)}
                  />
                ) : (
                  <Typography variant="label-semibold" color={tailwindColors.black.DEFAULT}>
                    {NumberFormatter.formatCurrency(item.amount, currency)}
                  </Typography>
                )}
              </div>
            ))}
        </div>
      </Box>
    </div>
  )
}

export default PaymentDistribution
